export default "\n{% block sw_product_media_form_cover_preview %}\n{% endblock %}\n";